import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onUnmounted } from 'vue';
import hubStorage from '@/helpers/hubStorage';
import { userInfo } from '@/constants';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        onUnmounted(() => {
            const isTestMode = hubStorage.getSessionItem(userInfo.IS_HUB_ADJUSTMENT_TEST_MODE);
            if (!isTestMode) {
                return;
            }
            const hub = vuexStore.getters['hubSelector/getterGetHubByLoginUser'];
            vuexStore.dispatch('hubSelector/setSubscribeHubInfo', [
                hub.value,
            ]);
            hubStorage.removeSessionItem(userInfo.IS_HUB_ADJUSTMENT_TEST_MODE);
            hubStorage.removeSelectedHubInfo();
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
